import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BizButton } from '../../../../../../FrontEndReact/src/Core/Components/Mini/BizButton';
import LaxhjalpenStudentListPanel from '../../../../../../FrontEndReact/src/Customers/Laxhjalpen/StudentList/LaxhjalpenStudentListPanel';
import { useLaxhjalpenStudentRegistration } from '../../Hooks/useStudentRegistration';
import LaxhjalpenHomeworkHelperStudentLinkPanel from './LaxhjalpenHomeworkHelperStudentLinkPanel';
import LaxhjalpenStudentRegistrationForm from './LaxhjalpenStudentRegistrationForm';
import './laxhjalpen-student-registration.scss';
import './laxhjalpen-student-registration-public.scss';

const LaxhjalpenStudentRegistrationPublicPage = () => {
	const { t } = useTranslation();
	const registration = useLaxhjalpenStudentRegistration({});
	const [activeTab, setActiveTab] = useState<'registration' | 'helperLink' | 'studentList'>('registration');
	const isRegistrationTab = activeTab === 'registration';
	const renderCreateButton = () => (
		<BizButton
			text={t('ADMIN.LAXHJALPEN.STUDENT_REGISTRATION.CREATE')}
			onClick={() => registration.onSubmit()}
			isLead={registration.isReadyToSubmit}
			disabled={registration.createStatus === 'LOADING'}
			state={registration.createStatus}
			legacy={false}
		/>
	);

	return (
		<div
			className={
				registration.formState.showValidation
					? 'biz-laxhjalpen-student-registration biz-laxhjalpen-student-registration-public show-validation'
					: 'biz-laxhjalpen-student-registration biz-laxhjalpen-student-registration-public'
			}
		>
			<div className='biz-laxhjalpen-student-registration-public__header'>
				<div>
					<h1 className='biz-laxhjalpen-student-registration-public__title'>
						{t('ADMIN.LAXHJALPEN.STUDENT_REGISTRATION.TITLE')}
					</h1>
					<p className='biz-laxhjalpen-student-registration-public__subtitle'>
						{t('ADMIN.LAXHJALPEN.STUDENT_REGISTRATION.INTRO_PUBLIC')}
					</p>
				</div>
				{/* {isRegistrationTab && renderCreateButton()} */}
			</div>

			<div className='biz-laxhjalpen-student-registration-public__tabs'>
				<button
					type='button'
					className={
						isRegistrationTab
							? 'biz-laxhjalpen-student-registration-public__tab biz-laxhjalpen-student-registration-public__tab--active'
							: 'biz-laxhjalpen-student-registration-public__tab'
					}
					onClick={() => setActiveTab('registration')}
				>
					{t('ADMIN.LAXHJALPEN.STUDENT_REGISTRATION.TAB_REGISTRATION')}
				</button>
				<button
					type='button'
					className={
						activeTab === 'studentList'
							? 'biz-laxhjalpen-student-registration-public__tab biz-laxhjalpen-student-registration-public__tab--active'
							: 'biz-laxhjalpen-student-registration-public__tab'
					}
					onClick={() => setActiveTab('studentList')}
				>
					{t('ADMIN.LAXHJALPEN.STUDENT_REGISTRATION.TAB_STUDENT_LIST')}
				</button>
				<button
					type='button'
					className={
						activeTab === 'helperLink'
							? 'biz-laxhjalpen-student-registration-public__tab biz-laxhjalpen-student-registration-public__tab--active'
							: 'biz-laxhjalpen-student-registration-public__tab'
					}
					onClick={() => setActiveTab('helperLink')}
				>
					{t('ADMIN.LAXHJALPEN.STUDENT_REGISTRATION.TAB_HELPER_LINK')}
				</button>
			</div>

			{isRegistrationTab && registration.createResult?.Success === false && (
				<div className='biz-laxhjalpen-student-registration-public__state biz-laxhjalpen-student-registration-public__state--error'>
					{registration.createResult.Message || t('ADMIN.LAXHJALPEN.STUDENT_REGISTRATION.GENERAL_ERROR')}
				</div>
			)}
			{isRegistrationTab && registration.createResult?.Success && registration.createStatus === 'SUCCESS' && (
				<div className='biz-laxhjalpen-student-registration-public__state biz-laxhjalpen-student-registration-public__state--success'>
					{t('ADMIN.LAXHJALPEN.STUDENT_REGISTRATION.SUCCESS_MESSAGE')}
				</div>
			)}

			{isRegistrationTab ? (
				<LaxhjalpenStudentRegistrationForm registration={registration} t={t} variant='public' />
			) : activeTab === 'helperLink' ? (
				<LaxhjalpenHomeworkHelperStudentLinkPanel t={t} variant='public' />
			) : (
				<LaxhjalpenStudentListPanel />
			)}

			{isRegistrationTab && (
				<div className='biz-laxhjalpen-student-registration-public__footer'>{renderCreateButton()}</div>
			)}
		</div>
	);
};

export default LaxhjalpenStudentRegistrationPublicPage;
